import React, { useState } from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { customAPI } from "services/utils/CustomAPI";
import { showToast } from "services/utils/Status";
import dayjs from "dayjs";
import { rowEndStyle } from "services/constants/Styles";
import { useSelector } from "react-redux";
import { CustomButtonWithBorder } from "components/CustomComponents/CustomButton";
import { tableRowSize } from "services/constants";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
} from "@mui/material";

export const PunchEntries = ({
  shiftDetails,
  attendanceDetails,
  setTabValue,
  setEditState,
  setRecallApi,
}) => {
  const { domain } = useSelector((state) => state.tokenReducer);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const formattedTime = attendanceDetails?.modified_at
    ? dayjs(attendanceDetails.modified_at).format("HH:mm")
    : "";
  const formattedDate = attendanceDetails?.modified_at
    ? dayjs(attendanceDetails.modified_at).format("DD-MM-YYYY")
    : "";

  const makeAbsent = async () => {
    let payload = {
      user: shiftDetails?.user_id,
      date: shiftDetails?.date?.split("-").reverse().join("-"),
      entries: [],
      attendance_record_id: attendanceDetails?.attendance_record_id,
      make_as_absent: true,
    };
    const response = await customAPI(
      `${domain}attendance_manual_entry/`,
      "PUT",
      payload
    );
    if (response.ok) {
      setEditState(true);
      setRecallApi(true);
      showToast("error", response?.responseDetails?.message);
      setTabValue(0);
    }
  };

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
  };

  return (
    <>
      <React.Fragment>
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelClose}
          onConfirm={() => {
            makeAbsent();
          }}
          title={"Mark As Absent"}
          message={"Are you sure you want to mark this day as Absent?"}
          confirmText={"Ok"}
          cancelText="Cancel"
        />
        <Box sx={{ border: "1px solid #00000040", borderRadius: 2 }}>
          <Table>
            <TableHead sx={{ bgcolor: themes?.primary }}>
              <TableRow sx={tableRowSize}>
                {["Date", "Time", "Entries", "Location"].map((h, i) => (
                  <TableCell key={i} sx={{ textAlign: "center" }}>
                    <Typography fontWeight={600}>{h}</Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {attendanceDetails?.punch_entries?.map((entry, index) => (
                <TableRow key={index} sx={tableRowSize}>
                  <TableCell sx={{ textAlign: "center" }}>
                    {entry?.date}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {entry?.time}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {entry?.direction}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {entry?.location ?? "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Box mb={2} display="flex" gap={1} sx={{ mt: 2, ml: 2 }}>
            <Grid container sx={{ paddingLeft: 1 }}>
              <Typography>
                Last modified by{" "}
                <b>
                  {attendanceDetails?.modified_by
                    ? attendanceDetails?.modified_by
                    : "-"}
                </b>{" "}
                on &nbsp;
                {attendanceDetails?.modified_at
                  ? formattedDate + " ; " + formattedTime
                  : "None"}
              </Typography>
            </Grid>
          </Box>
          <Mui.Grid
            container
            gap={1}
            sx={{ ...rowEndStyle, paddingRight: 1, paddingBottom: 2 }}
          >
            {attendanceDetails?.punch_entries?.length > 0 && (
              <CustomButtonWithBorder
                actionFuntion={() => {
                  setShowConfirmationDialog(true);
                }}
                actionName="Mark As Absent"
                typeName="button"
              />
            )}
          </Mui.Grid>
        </Box>
      </React.Fragment>
    </>
  );
};
